import React, { useEffect } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  Text,
  RadioGroup,
  Stack,
  Box,
  Flex,
} from "@chakra-ui/react";

import { CustomInputWField } from "../../../../components/CustomInputWField";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";

import { RadioButtonField } from "../../../../components/RadioButtonField";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import CustomDropzone from "../../../../components/CustomDropzone";
import FileInformation from "../../../../components/FileInformation";

export const ProfissionalizacaoCadastrar = ({
  initialValues,
  idAnexo,
  scrollToField,

  anexoCurriculoEditado,
  setAnexoCurriculoEditado,

  anexoCursoProfEditado,
  setAnexoCursoProfEditado,

  anexoAprendizEditado,
  setAnexoAprendizEditado,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { setCadastrarProfCrianca } = useAppContext();

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Group
      title="Profissionalização"
      border={["12", "20", "27"].includes(idAnexo) ? "3px solid #4299E199" : ""}
      scrollToField={
        ["12", "20", "27"].includes(idAnexo) ? scrollToField : null
      }
    >
      <Grid mt="15px" templateColumns="repeat(3, 1fr)" gap="25px" rowGap="20px">
        {setCadastrarProfCrianca(hasFormChanged(initialValues, values))}
        <GridItem
          position="relative"
          colSpan={{ base: 2, lg: 1 }}
          mb={{ base: 32, sm: 24, lg: 15 }}
        >
          <Text
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={"Possui Curso Profissionalizante?*"}
          >
            Possui Curso Profissionalizante?*
          </Text>
          <Field name="cursoProfissionalizante">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.cursoProfissionalizante &&
                  form.touched.cursoProfissionalizante
                }
                id="radioTratamento"
                width="max-content"
                position="absolute"
                top="0"
                zIndex={"1"}
                right={"-100px"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) =>
                    setFieldValue("cursoProfissionalizante", value)
                  }
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="cursoProfissionalizante"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="cursoProfissionalizante"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-16">
                  {form.errors.cursoProfissionalizante}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
          {values.cursoProfissionalizante === "S" ? (
            <Box
              mt={{ base: "6", sm: "0" }}
              position="absolute"
              right={{
                lg: values.originalCursoProfissionalizante
                  ? "-349.5px"
                  : "-450px",
                xl: values.originalCursoProfissionalizante
                  ? "-369px"
                  : "-470px",
              }}
              top={{ base: "10", lg: "0" }}
            >
              {anexoCursoProfEditado ||
              !values.originalCursoProfissionalizante ? (
                <Flex>
                  <CustomDropzone
                    formProps={{ setFieldValue }}
                    title={`Anexar Certificado de Curso Profissionalizante*`}
                    fieldName="anexoCursoProfissionalizante"
                    setAnexoNaoEditado={
                      values.originalCursoProfissionalizante
                        ? () => {
                            setAnexoCursoProfEditado(false);
                          }
                        : null
                    }
                    height="42px"
                    width={"216px"}
                  />
                </Flex>
              ) : (
                values.originalCursoProfissionalizante && (
                  <Flex>
                    <FileInformation
                      label={`Anexar Certificado de Curso Profissionalizante*`}
                      name={values.originalCursoProfissionalizante.nomeArquivo}
                      path={values.originalCursoProfissionalizante.path
                        .toString()
                        .split("/")
                        .pop()}
                      setAnexoEditado={() => {
                        setAnexoCursoProfEditado(true);
                        setFieldValue("originalCursoProfissionalizante", null);
                      }}
                      isVisualizacao={false}
                      height="42px"
                      width={"216px"}
                    />
                  </Flex>
                )
              )}
            </Box>
          ) : (
            ""
          )}
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
          <Text
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={"Trabalha Atualmente?*"}
          >
            Trabalha Atualmente?*
          </Text>
          <Field name="trabalho">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.trabalho && form.touched.trabalho}
                id="trabalho"
                width="max-content"
                position="absolute"
                top="0"
                zIndex={"1"}
                right={"-100px"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) => setFieldValue("trabalho", value)}
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="trabalho"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="trabalho"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-16">
                  {form.errors.trabalho}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
          <Text
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={"Faz Estágio?*"}
          >
            Faz Estágio?*
          </Text>
          <Field name="estagio">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.estagio && form.touched.estagio}
                id="estagio"
                width="max-content"
                position="absolute"
                top="0"
                zIndex={"1"}
                right={"-100px"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) => setFieldValue("estagio", value)}
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="estagio"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="estagio"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-16">
                  {form.errors.estagio}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        <GridItem position="relative" colSpan={{ base: 2, lg: 1 }}>
          <Text
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            whiteSpace={"nowrap"}
            htmlFor={`Matriculado no Programa Jovem Aprendiz?*`}
          >
            Matriculado no Programa Jovem Aprendiz?*
          </Text>

          <Field name="jovemAprendiz">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.jovemAprendiz && form.touched.jovemAprendiz
                }
                id="jovemAprendiz"
                width="max-content"
                position="absolute"
                top={{ base: "6", sm: "0" }}
                zIndex={"1"}
                right={"-100px"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) => setFieldValue("jovemAprendiz", value)}
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="jovemAprendiz"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="jovemAprendiz"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-16">
                  {form.errors.jovemAprendiz}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        {values.jovemAprendiz === "S" && (
          <GridItem
            position="relative"
            colSpan={{ base: 2, lg: 1 }}
            mb={{ base: 32, sm: 24, lg: 15 }}
          >
            <Box
              w={{ base: "150%", lg: "140%", xl: "130%" }}
              maxW={{ lg: 500 }}
            >
              <CustomInputWField
                fieldName="nomeEmpresa"
                label="Nome da Empresa*"
                maxLength={255}
                placeholder="Informe o Nome"
                onChange={(e) => setFieldValue("nomeEmpresa", e.target.value)}
              />
            </Box>

            <Box
              display={{ base: "none", lg: "block" }}
              width="max-content"
              position="absolute"
              top={{ base: "6", sm: "0" }}
              zIndex={"1"}
              right={"-100px"}
            />
            {values.jovemAprendiz === "S" ? (
              <Box
                mt={{ base: "10", sm: "48px", lg: "0" }}
                position="absolute"
                right={{
                  lg: values.originalAnexoJovemAprendiz ? "-347.5px" : "-450px",
                  xl: values.originalAnexoJovemAprendiz ? "-367.5px" : "-470px",
                }}
                top={{ base: "10", lg: "0" }}
              >
                {anexoAprendizEditado || !values.originalAnexoJovemAprendiz ? (
                  <Flex>
                    <CustomDropzone
                      whiteSpace={true}
                      formProps={{ setFieldValue }}
                      title={`Anexar Inscrição no Programa Jovem Aprendiz*`}
                      fieldName="anexoProgramaJovemAprendiz"
                      setAnexoNaoEditado={
                        values.originalAnexoJovemAprendiz
                          ? () => {
                              setAnexoAprendizEditado(false);
                            }
                          : null
                      }
                      height="42px"
                      width={"216px"}
                    />
                  </Flex>
                ) : (
                  values.originalAnexoJovemAprendiz && (
                    <FileInformation
                      label={`Anexar Inscrição no Programa Jovem Aprendiz*`}
                      name={values.originalAnexoJovemAprendiz.nomeArquivo}
                      path={values.originalAnexoJovemAprendiz.path
                        .toString()
                        .split("/")
                        .pop()}
                      setAnexoEditado={() => {
                        setAnexoAprendizEditado(true);
                        setFieldValue("originalAnexoJovemAprendiz", null);
                      }}
                      isVisualizacao={false}
                      height="42px"
                      width={"216px"}
                    />
                  )
                )}
              </Box>
            ) : (
              ""
            )}
          </GridItem>
        )}
        {values.jovemAprendiz === "S" ? <GridItem colSpan={{ lg: 2 }} /> : ""}
        <GridItem
          position="relative"
          colSpan={{ base: 2, lg: 1 }}
          mb={values.curriculoVitae === "S" && { base: 28, lg: 16 }}
        >
          <Text
            mt={{ base: "6", sm: "0" }}
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            whiteSpace={"nowrap"}
            htmlFor={`Possui Currículo Vitae?`}
          >
            Possui Currículo Vitae?*
          </Text>

          <Field name="curriculoVitae">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.curriculoVitae && form.touched.curriculoVitae
                }
                id="curriculoVitae"
                top={{ base: "6", sm: "0" }}
                width="max-content"
                position="absolute"
                zIndex={"1"}
                right={"-100px"}
              >
                <RadioGroup
                  value={field.value}
                  onChange={(value) => setFieldValue("curriculoVitae", value)}
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="curriculoVitae"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="curriculoVitae"
                      value="N"
                      label="Não"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-16">
                  {form.errors.curriculoVitae}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
          {values.curriculoVitae === "S" && (
            <Box
              mt={{ base: "6", sm: "0" }}
              position="absolute"
              right={{ lg: "-343px", xl: "-363px" }}
              top={{ base: "10", lg: "0" }}
            >
              {anexoCurriculoEditado || !values.originalAnexoCurriculo ? (
                <Flex>
                  <CustomDropzone
                    whiteSpace={true}
                    formProps={{ setFieldValue }}
                    title={`Anexar Currículo Vitae ${
                      values.curriculoVitae === "S" ? "*" : ""
                    }`}
                    fieldName="anexoCurriculo"
                    setAnexoNaoEditado={
                      values.originalAnexoCurriculo
                        ? () => {
                            setAnexoCurriculoEditado(false);
                          }
                        : null
                    }
                    height="42px"
                    width={"216px"}
                  />
                </Flex>
              ) : (
                values.originalAnexoCurriculo && (
                  <FileInformation
                    label={`Anexar Currículo Vitae ${
                      values.curriculoVitae === "S" ? "*" : ""
                    }`}
                    name={values.originalAnexoCurriculo.nomeArquivo}
                    path={values.originalAnexoCurriculo.path
                      .toString()
                      .split("/")
                      .pop()}
                    setAnexoEditado={() => {
                      setAnexoCurriculoEditado(true);
                      setFieldValue("originalAnexoCurriculo", null);
                    }}
                    isVisualizacao={false}
                    height="42px"
                    width={"216px"}
                  />
                )
              )}
            </Box>
          )}
        </GridItem>
      </Grid>
    </Group>
  );
};
